// 画布元素状态管理
export default {
  namespaced: true,
  
  state: {
    elements: [],
    selectedElementIndex: null,
    history: {
      past: [],
      future: []
    },
    dragState: {
      isDragging: false,
      elementIndex: null,
      startPosition: { x: 0, y: 0 },
      currentPosition: { x: 0, y: 0 }
    }
  },
  
  mutations: {
    ADD_ELEMENT(state, element) {
      state.elements.push(element)
      state.selectedElementIndex = state.elements.length - 1
    },
    
    REMOVE_ELEMENT(state, index) {
      if (index >= 0 && index < state.elements.length) {
        state.elements.splice(index, 1)
        if (state.selectedElementIndex === index) {
          state.selectedElementIndex = null
        } else if (state.selectedElementIndex > index) {
          state.selectedElementIndex--
        }
      }
    },
    
    UPDATE_ELEMENT(state, { index, element }) {
      if (index >= 0 && index < state.elements.length) {
        state.elements.splice(index, 1, element)
      }
    },
    
    SELECT_ELEMENT(state, index) {
      state.selectedElementIndex = index
    },
    
    CLEAR_SELECTION(state) {
      state.selectedElementIndex = null
    },
    
    SET_ELEMENTS(state, elements) {
      state.elements = elements
    },
    
    SAVE_HISTORY(state) {
      state.history.past.push(JSON.parse(JSON.stringify(state.elements)))
      state.history.future = []
      
      // 限制历史记录数量
      if (state.history.past.length > 50) {
        state.history.past.shift()
      }
    },
    
    UNDO(state) {
      if (state.history.past.length > 0) {
        state.history.future.push(JSON.parse(JSON.stringify(state.elements)))
        const previousState = state.history.past.pop()
        state.elements = previousState
        state.selectedElementIndex = null
      }
    },
    
    REDO(state) {
      if (state.history.future.length > 0) {
        state.history.past.push(JSON.parse(JSON.stringify(state.elements)))
        const nextState = state.history.future.pop()
        state.elements = nextState
        state.selectedElementIndex = null
      }
    },
    
    START_DRAG(state, { elementIndex, startPosition }) {
      state.dragState.isDragging = true
      state.dragState.elementIndex = elementIndex
      state.dragState.startPosition = startPosition
      state.dragState.currentPosition = startPosition
    },
    
    UPDATE_DRAG(state, position) {
      state.dragState.currentPosition = position
    },
    
    END_DRAG(state) {
      state.dragState.isDragging = false
      state.dragState.elementIndex = null
    }
  },
  
  actions: {
    addElement({ commit }, element) {
      commit('SAVE_HISTORY')
      commit('ADD_ELEMENT', element)
    },
    
    removeElement({ commit }, index) {
      commit('SAVE_HISTORY')
      commit('REMOVE_ELEMENT', index)
    },
    
    updateElement({ commit }, payload) {
      commit('SAVE_HISTORY')
      commit('UPDATE_ELEMENT', payload)
    },
    
    selectElement({ commit }, index) {
      commit('SELECT_ELEMENT', index)
    },
    
    clearSelection({ commit }) {
      commit('CLEAR_SELECTION')
    },
    
    undo({ commit }) {
      commit('UNDO')
    },
    
    redo({ commit }) {
      commit('REDO')
    },
    
    startDrag({ commit }, payload) {
      commit('START_DRAG', payload)
    },
    
    updateDrag({ commit }, position) {
      commit('UPDATE_DRAG', position)
    },
    
    endDrag({ commit }) {
      commit('END_DRAG')
    }
  },
  
  getters: {
    selectedElement: (state) => {
      return state.selectedElementIndex !== null 
        ? state.elements[state.selectedElementIndex] 
        : null
    },
    
    canUndo: (state) => state.history.past.length > 0,
    
    canRedo: (state) => state.history.future.length > 0,
    
    tableElements: (state) => state.elements.filter(el => el.type === 'table'),
    
    textElements: (state) => state.elements.filter(el => el.type === 'text')
  }
}
